import { TiposBeneficiosReforma } from "@enums/tipos-beneficios-reforma.enum";
import { IFaqCard } from "../interfaces/faq-card.interface";
import { IRightColumnData } from "../interfaces/right-column-data.interface";

export interface ICardReformaPensiones {
  id: string;
  listCodes: string[];
  title: string;
  statusText: string;
  statusClass: string;
  infoBoxMessage: string;
  infoBoxMessageStrong: string;
  requestLinkText: string;
  afterStrong: boolean;
  enabledLabel?: boolean;
  enabledDetail?: boolean;
  sex: FiltroSexosBeneficio;
  codigoBackBeneficioOtorgado?: string;
}

export enum FiltroSexosBeneficio {
  M = "M",
  F = "F",
  TODOS = "TODOS"
}


export interface PGUIncreaseStep {
  date: string;
  details: string[];
}

export interface PGUAccessCondition {
  condition: string;
}

// Define un tipo o interfaz para mayor claridad y seguridad (opcional pero recomendado)
export type DescripcionReforma = {
  type: "text" | "imagen";
  content?: string; // Para el texto
  src?: string; // Para la ruta de la imagen
  srcMobile?: string;
  alt?: string; // Texto alternativo para la imagen
};

export const BENEFICIO_SELECCIONADO_REFORMAS = "beneficio_seleccionado_reforma";
export const TITLE_FAQS = "Preguntas frecuentes";

export const URL_CAPITAL_PLAY_REFORMA_DETALLE = "https://capitalplay.afpcapital.cl/reforma";

export enum CodigosBackBeneficiosReforma {
  BAC = "BAC",
  CEV = "CEV",
  CBAC = "CBAC",
  CCEV = "CCEV",
}

export const CARD_REFORMA_PENSIONES: ICardReformaPensiones[] = [
  {
    id: TiposBeneficiosReforma.BAC,
    listCodes: [CodigosBackBeneficiosReforma.BAC, CodigosBackBeneficiosReforma.CBAC],
    title: "Beneficio por Años Cotizados",
    statusText: "",
    statusClass: "",
    infoBoxMessage: "",
    infoBoxMessageStrong: "",
    requestLinkText: "Revisa el detalle del beneficio",
    afterStrong: true,
    enabledLabel: false,
    enabledDetail: true,
    sex: FiltroSexosBeneficio.TODOS,
  },
  {
    id: TiposBeneficiosReforma.CEV,
    listCodes: [CodigosBackBeneficiosReforma.CEV, CodigosBackBeneficiosReforma.CCEV],
    title: "Compensación por Diferencia de Expectativa de Vida",
    statusText: "",
    statusClass: "",
    infoBoxMessage: "",
    infoBoxMessageStrong: "",
    requestLinkText: "Revisa el detalle del beneficio",
    afterStrong: false,
    enabledLabel: false,
    enabledDetail: true,
    sex: FiltroSexosBeneficio.F,
  },
];

export const FAQ_CARD_REFORMA_PENSIONES: IFaqCard[] = [
  {
    step: 1,
    questions: [
      {
        title: "Preguntas frecuentes",
        subtitle: "",
        items: [
          {
            question: "¿Cuándo aumentará la PGU?",
            answer1:
              "El aumento de la PGU se hará de forma gradual por etapas, dependiendo de tu edad:",
            imagen:
              "https://storage.googleapis.com/src-pwa-2/nueva-web/reforma-pensiones/cuando-aumenta-pgu.png",
            isOpen: false,
            pguAnswer: [
              {
                date: "A partir de septiembre de 2025:",
                details: [
                  "Si tienes 82 años o más, la PGU aumentará automáticamente.",
                  "Si eres una persona beneficiaria de la Pensión Básica Solidaria de Invalidez (PBSI), recibirás $250.000.",
                  "Si recibes el Aporte Previsional Solidario de Invalidez (APSI) recibirás un monto complementario para alcanzar el valor de la PGU.",
                  "Si tienes el Subsidio de Discapacidad, el monto subirá de forma automática a la mitad de la PGU.",
                  "Deberás realizar una solicitud, si es que recibes una pensión de gracia o por leyes de reparación, y tienes 82 años o más.",
                ],
              },
              {
                date: "A partir de septiembre de 2026:",
                details: [
                  "Si tienes 75 años o más, aumentará automáticamente.",
                  "Deberás realizar una solicitud, si es que recibes una pensión de gracia o por leyes de reparación, y tienes 82 años o más.",
                ],
              },
              {
                date: "A partir de septiembre de 2027:",
                details: [
                  "Si tienes 65 años o más, aumentará automáticamente.",
                  "Deberás realizar una solicitud, si es que recibes una pensión de gracia o por leyes de reparación, y tienes 82 años o más.",
                  "Si eres una persona montepiada de Capredena o Dipreca, podrás solicitar un monto complementario para alcanzar el valor que tenga la PGU en esa fecha.",
                ],
              },
            ],
          },
          {
            question: "¿Quiénes serán los nuevos beneficiarios?",
            answer1:
              "Gracias a las implementaciones que trae la Reforma de Pensiones, nuevas personas podrán acceder a la PGU:",
            imagen:
              "https://storage.googleapis.com/src-pwa-2/nueva-web/reforma-pensiones/beneficiarios-pgu.png",
            isOpen: false,
            pguAnswer2: [
              {
                condition:
                  "Si recibes una pensión por la Ley Rettig (Ley N° 19.123), Ley Valech (Ley N° 19.992), por ser una persona exonerada política, (Ley N° 19.582) o por ser pensionada de gracia (Ley N° 18.056), podrás solicitar el monto completo en la fecha que te corresponda según tu edad.",
              },
              {
                condition:
                  "Si eres una persona pensionada de montepío de la Caja de Previsión de la Defensa Nacional (Capredena) o la Dirección de Previsión de Carabineros de Chile (Dipreca), podrás solicitar un monto que complemente tu pensión para alcanzar el valor de la PGU, siempre que no recibas una pensión extra. Podrás hacer la solicitud a partir de septiembre de 2027.",
              },
            ],
          },
          {
            question: "¿Dónde consultar por el aumento y acceso?",
            answer1: "",
            isOpen: false,
            pguAnswer3:
              "Si es que ya recibes la PGU, puedes consultar sobre tu aumento, con tu RUT y fecha de nacimiento a través de",
          },
        ],
      },
    ],
  },
  {
    step: 2,
    questions: [
      {
        title: "Preguntas frecuentes",
        subtitle: "",
        items: [
          {
            question: "¿Cuándo se pagará el beneficio?",
            answer1:
              "El Beneficio por Años Cotizados se comenzará a pagar desde enero de 2026, y se verá reflejado junto a tu pensión. Puedes revisar el detalle del monto en el comprobante de pago de dicho mes.",
            isOpen: false,
          },
          {
            question: "¿Quién define a los beneficiarios?",
            answer1: "El Instituto de Previsión Social (IPS) es la entidad que determina a los beneficiarios de las prestaciones de la Reforma de Pensiones.",
            isOpen: false,
          },
          {
            question: "¿Cómo se debe solicitar?",
            answer1: "El Beneficio por Años Cotizados se otorga de manera automática, es decir, no requiere postulación. Sin embargo, es fundamental que los pensionados mantengan su información de pago y contacto actualizada, a fin de que puedan acceder al beneficio sin fricciones.",
            isOpen: false,
          },
        ],
      },
    ],
  },
  {
    step: 3,
    questions: [
      {
        title: "Preguntas frecuentes",
        subtitle: "",
        items: [
          {
            question: "¿Qué significa que no haya exclusión por PGU?",
            answer1: "Que no haya exclusión por PGU, quiere decir:",
            isOpen: false,
            imagen:
              "https://storage.googleapis.com/src-pwa-2/nueva-web/reforma-pensiones/exclusion-pgu.png",
            pguAnswer: [
              "Antes, solo quienes no recibían PGU podían ajustar su pensión a 3 UF.",
              "Con la reforma, se eliminó esta restricción y se habilitó el ajuste a 2 UF para todos los pensionados bajo Retiro Programado, incluyendo quienes reciben PGU.",
            ],
          },
          {
            question: "¿Cómo solicitar el beneficio?",
            answer1: "",
            isOpen: false,
            pguAnswer2:
              "Desde septiembre 2025, podrás hacer la solicitud directamente en AFP Capital, en nuestras sucursales, o a través de nuestros canales de atención virtuales.",
          },
          {
            question: "¿Cuáles son las consideraciones del ajuste?",
            answer1: "Este beneficio tiene las siguientes consideraciones:",
            isOpen: false,
            imagen:
              "https://storage.googleapis.com/src-pwa-2/nueva-web/reforma-pensiones/consideraciones-ajuste.png",
            pguAnswer3: [
              "El ajuste es voluntario.",
              "Aumentar el monto de la pensión implica agotar más rápido los fondos previsionales.",
              "Las AFP deben informar a los afiliados sobre esta opción y sus efectos.",
            ],
          },
        ],
      },
    ],
  },
  {
    step: 4,
    questions: [
      {
        title: "Preguntas frecuentes",
        subtitle: "",
        items: [
          {
            question: "¿Cuándo se pagará el beneficio?",
            answer1:
              "La Compensación a Mujeres se comenzará a pagar en enero de 2026, y se verá reflejado junto a tu pensión. Puedes revisar el detalle del monto en el comprobante de pago de dicho mes.",
            isOpen: false,
          },
          {
            question: "¿Quién define a los beneficiarios?",
            answer1: "El Instituto de Previsión Social (IPS) es la organización que determina a los beneficiarios de las prestaciones de la Reforma de Pensiones.",
            isOpen: false,
          },
          {
            question: "¿Cómo se debe solicitar?",
            answer1: "La Compensación a Mujeres se otorga de manera automática, es decir, no requiere postulación. Sin embargo, es fundamental que los pensionados mantengan su información de pago y contacto actualizada, a fin de que puedan acceder al beneficio sin fricciones.",
            isOpen: false,
          },
        ],
      },
    ],
  },
];

export const DESCRIPCION_DETALLES_REFORMA_PENSIONES = {
  [TiposBeneficiosReforma.PGU]: [
    {
      type: "text",
      content:
        "Con la implementación de la Reforma de Pensiones, la PGU aumentará de $224.004 a $250.000, a partir de septiembre de 2025, y se entregará gradualmente según la edad que tengas.",
    },
    {
      type: "imagen",
      src: "https://storage.googleapis.com/src-pwa-2/nueva-web/reforma-pensiones/aumento-pgu-septiembre.png", // ¡Asegúrate de que la ruta sea correcta!
    },
    {
      type: "text",
      content:
        "Esta modificación permitirá que el monto del Subsidio de Discapacidad se eleve a $125.000 (lo que equivalente a la mitad de la PGU). En el caso de quienes reciben un porcentaje de PGU, según la pensión que tienen, el monto incrementará de manera proporcional.",
    },
    {
      type: "text",
      content:
        "Además, este cambio permitirá que nuevas personas puedan convertirse en beneficiarias, como: pensionados o pensionadas por leyes de reparación, de Capredena y de Dipreca.",
    },
  ],
  [TiposBeneficiosReforma.BAC]: [
    {
      type: "text",
      content:
        "Desde enero 2026, todos los pensionados de 65 años o más, podrán recibir 0,1 UF mensual por cada año que hayan cotizado.",
    },
    {
      type: "imagen",
      src: "https://storage.googleapis.com/src-pwa-2/nueva-web/reforma-pensiones/condiciones-anos-cotizados.png", // ¡Asegúrate de que la ruta sea correcta!
    },
    {
      type: "text",
      content: '["Las mujeres deben tener al menos 120 cotizaciones (equivalentes a 10 años) y los hombres al menos 240 (equivalentes a 20 años), continuas o discontinuas.", "El tope máximo son 300 cotizaciones.", "Se excluyen los pensionados de Capredena o Dipreca."]',
    },
    {
      type: "text",
      content: "https://capitalplay.afpcapital.cl/reforma/conversatorio-beneficio-anos-cotizados",
    }
  ],
  [TiposBeneficiosReforma.UF_RETIRO_PROGRAMADO]: [
    {
      type: "text",
      content:
        "A partir del  1 de septiembre de 2025, las personas pensionadas bajo la modalidad de Retiro Programado o Renta Temporal podrán solicitar que su pensión mensual se ajuste a 2 UF.",
    },
    {
      type: "imagen",
      src: "https://storage.googleapis.com/src-pwa-2/nueva-web/reforma-pensiones/ajuste-pension-2-uf.png", // ¡Asegúrate de que la ruta sea correcta!
    },
    {
      type: "text",
      content:
        '["Estar pensionado bajo la modalidad de retiro programado o renta temporal.","Recibir una pensión inferior a 2 UF mensuales.","Contar con saldo suficiente en la cuenta individual para cubrir el ajuste, permitiendo que sus fondos se agoten en forma acelerada.","No hay exclusión por recibir PGU."]',
    },
  ],
  [TiposBeneficiosReforma.CEV]: [
    {
      type: "text",
      content:
        "Desde enero 2026, todas las pensionadas de 65 años o más, podrán recibir un aporte extra en su pensión de vejez o invalidez, para compensar la diferencia de expectativa de vida con los hombres.",
    },
    {
      type: "imagen",
      src: "https://storage.googleapis.com/src-pwa-2/nueva-web/reforma-pensiones/CEV_condiciones_desktop.png",
      srcMobile: "https://storage.googleapis.com/src-pwa-2/nueva-web/reforma-pensiones/CEV_condiciones_mobile.png",
    },
    {
      type: "text",
      content: '["Haber cotizado el Fondo Autónomo de Protección Previsional (FAPP) antes de los 50 años (salvo afiliadas antes del 1 de agosto de 2025, quienes no deberán cumplir este requisito)."]',
    },
    {
      type: "text",
      content: "https://capitalplay.afpcapital.cl/reforma/reforma-previsional-2025-beneficios-mujeres",
    }
  ],
};

export const NO_APLICA_BENEFICIOS_REFORMA_PENSIONES_MENSAJE = {
  [TiposBeneficiosReforma.PGU]:
    "Lo sentimos, el beneficio de Aumento de la Pensión Garantizada Universal no está disponible para tu caso.",
  [TiposBeneficiosReforma.BAC]:
    "Lo sentimos, el beneficio por Años Cotizados no está disponible para tu caso.",
  [TiposBeneficiosReforma.UF_RETIRO_PROGRAMADO]:
    "Lo sentimos, el beneficio de Ajuste de pensión a 2 UF no está disponible para tu caso, porque actualmente ya recibes un monto mayor.",
  [TiposBeneficiosReforma.CEV]:
    "Lo sentimos, el beneficio de Compensación a Mujeres no está disponible para tu caso.",
};

export const RIGHT_COLUMN_DATA_REFORMA: IRightColumnData[] = [
  {
    sectionTitle: "Revisa",
    sections: [
      {
        title: "Aumento de la Pensión Garantizada Universal (PGU)",
        element: "statusElement",
        active: true,
      },
      {
        title: "¿Cuándo aumentará la PGU?",
        element: "faq-answer-0",
      },
      {
        title: "¿Quiénes serán los nuevos beneficiarios?",
        element: "faq-answer-1",
      },
      {
        title: "¿Dónde consultar por el aumento y acceso?",
        element: "faq-answer-2",
      },
    ],
  },
  {
    sectionTitle: "Revisa",
    sections: [
      {
        title: "Beneficio por Años Cotizados",
        element: "statusElement",
        active: true,
      },
      {
        title: "¿Cuándo se pagará el beneficio?",
        element: "faq-answer-0",
      },
      {
        title: "¿Quién define a los beneficiarios?",
        element: "faq-answer-1",
      },
      {
        title: "¿Cómo se debe solicitar?",
        element: "faq-answer-2",
      },
    ],
  },
  {
    sectionTitle: "Revisa",
    sections: [
      {
        title: "Ajuste de pensión en 2 UF",
        element: "statusElement",
        active: true,
      },
      {
        title: "¿Qué significa que no haya exclusión por PGU?",
        element: "faq-answer-0",
      },
      {
        title: "¿Cómo solicitar el beneficio?",
        element: "faq-answer-1",
      },
      {
        title: "¿Cuáles son las consideraciones del ajuste?",
        element: "faq-answer-2",
      },
    ],
  },
  {
    sectionTitle: "Revisa",
    sections: [
      {
        title: "Compensación a Mujeres",
        element: "statusElement",
        active: true,
      },
      {
        title: "¿Cuándo se pagará el beneficio?",
        element: "faq-answer-0",
      },
      {
        title: "¿Quién define a los beneficiarios?",
        element: "faq-answer-1",
      },
      {
        title: "¿Cómo se debe solicitar?",
        element: "faq-answer-2",
      },
    ],
  },
];

export enum TiposTextosImportanteReformaPensiones {
  PaginaBeneficiosReforma = "PaginaBeneficiosReforma",
  PaginaDetalleBeneficiosReforma = "PaginaDetalleBeneficiosReforma",
}


